import { render, staticRenderFns } from "./VettingDuplicate.vue?vue&type=template&id=38aa55cb"
import script from "./VettingDuplicate.vue?vue&type=script&lang=js"
export * from "./VettingDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports